var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		site.frontpage.locationHeading();


		site.owl.init('#main .carousel-curators .items', {
			nav:true,
			navText:["<i class=\"fa fa-angle-left\"></i>","<i class=\"fa fa-angle-right\"></i>"],
			items:1,
			loop:true,
			dots:false
		});

		/*
		site.owl.init('#main .social div.menu', {
			nav:true,
			navText:["<i class=\"fa fa-angle-left\"></i>","<i class=\"fa fa-angle-right\"></i>"],
			loop:false,
			dots:false,
			autoWidth:true,
			responsiveClass:true,
			responsive: {
				0: {
					items:2,
					slideBy:2
				},
				600: {
					items:3,
					slideBy:3
				},
				1000: {
					items:8,
					slideBy:8
				}
			}
		});
		*/

		var swiper = new Swiper('#main .swiper-container', {
			direction: 'vertical',
			autoHeight: true,
			//freeMode: true,
			slidesPerView: 6,
			//mousewheelControl: true,
			paginationClickable: true,
			keyboardControl: true,
			spaceBetween:28,
			// Navigation arrows
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			// Responsive breakpoints
			breakpoints: {
				// when window width is <= 320px
				320: {
					slidesPerView: 20
				},
				// when window width is <= 480px
				480: {
					slidesPerView: 20
				},
				// when window width is <= 640px
				640: {
					slidesPerView: 20
				}
			}
		});
	},
	locationHeading : function() {
		var niceText = $('#main .map-items .category-title').text();
		var openSpan = '<span class="grey">', closeSpan = '</span>';
		niceText = niceText.split(' ');
		niceText.unshift( openSpan );
		niceText.splice( 2, 0, closeSpan );
		niceText = niceText.join(' ');
		$('#main .map-items .category-title').html( niceText );
	}
};

site.extras = {
	init: function() {
		var $body = $('body');
		if ($body.is('.roomView')) {
			site.extras.roomCarousel();
		}
	},
	roomCarousel: function() {
		site.owl.init('#extras .images', {
			nav:true,
			navText:["",""],
			items:1,
			dots:false,
		});
	}
};

site.gallery = {
	init: function() {
		var grid = document.querySelector('.grid');
		var iso = new Isotope( grid, {
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer'
			}
		});
		imagesLoaded( grid ).on( 'progress', function() {
			iso.layout();
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var doc = document.documentElement;
	doc.setAttribute('data-useragent', navigator.userAgent);

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.extras')) {
		site.extras.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
